import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

export default function ValidationSummary({
  validationEmployees,
  validationCounts,
  onSelectAllAffected,
  onSelectEmployee,
  selectedEmployees,
}) {
  const [expanded, setExpanded] = useState(validationEmployees.length > 0);

  if (validationEmployees.length === 0) {
    return (
      <div className="bg-green-50 border border-green-200 rounded-lg px-4 py-3 mb-6 flex items-center gap-2 text-sm text-green-800">
        <Icon name="CheckCircle" size={16} />
        All employees passed validation for this period.
      </div>
    );
  }

  return (
    <div className="bg-card border border-border rounded-lg mb-6 overflow-hidden">
      <button
        type="button"
        onClick={() => setExpanded(!expanded)}
        className="w-full flex items-center justify-between px-4 py-3 hover:bg-muted/40 text-left"
      >
        <div className="flex items-center gap-3">
          <Icon name="AlertTriangle" size={18} className="text-amber-600" />
          <div>
            <p className="font-medium text-foreground">Validation Issues</p>
            <p className="text-sm text-muted-foreground">{validationEmployees.length} employees need attention</p>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <div className="hidden sm:flex gap-2 text-xs">
            <span className="px-2 py-1 rounded bg-amber-100 text-amber-800">Att: {validationCounts.attendance}</span>
            <span className="px-2 py-1 rounded bg-amber-100 text-amber-800">Dep: {validationCounts.deployment}</span>
            <span className="px-2 py-1 rounded bg-amber-100 text-amber-800">Bank: {validationCounts.bank}</span>
          </div>
          <Icon name={expanded ? 'ChevronUp' : 'ChevronDown'} size={18} className="text-muted-foreground" />
        </div>
      </button>

      {expanded && (
        <div className="px-4 pb-4 border-t border-border">
          <div className="flex justify-end mt-3 mb-2">
            <Button variant="outline" size="sm" onClick={onSelectAllAffected}>
              Select All Affected
            </Button>
          </div>
          <div className="max-h-48 overflow-y-auto border border-border rounded-lg divide-y divide-border">
            {validationEmployees.map((emp) => (
              <div key={emp.id} className="flex items-center justify-between gap-3 px-3 py-2">
                <div className="min-w-0">
                  <p className="text-sm font-medium truncate">{emp.name}</p>
                  <div className="flex flex-wrap gap-1 mt-0.5">
                    {emp.validationIssues.map((issue) => (
                      <span key={issue} className="px-1.5 py-0.5 rounded text-xs bg-amber-100 text-amber-800">
                        {issue.replace('Missing ', '')}
                      </span>
                    ))}
                  </div>
                </div>
                <Button
                  variant="outline"
                  size="xs"
                  disabled={selectedEmployees.includes(emp.id)}
                  onClick={() => onSelectEmployee(emp.id)}
                >
                  {selectedEmployees.includes(emp.id) ? 'Selected' : 'Select'}
                </Button>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
